// KT-89: axtarış normalizasiyası — SQL app.search_norm (0036) ilə eyni qayda.
// Masaüstü (.exe, lokal SQLite) və veb süzgəci bunu işlədir; nəticə serverlə üst-üstə düşməlidir.
// Runtime paketi deyil (shared yalnız tip ixrac edir): Vite ilə yığılan istehlakçı (veb, Tauri) bu faylı birbaşa idxal edir.

const FROM = 'əçşğıöü';
const TO = 'ecsgiou';

/** Kiçik hərf, «İ» → i, ə/ç/ş/ğ/ı/ö/ü → e/c/s/g/i/o/u. «Çörək» → «corek». */
export function searchNorm(s: string | null | undefined): string {
  const lower = (s ?? '').toLowerCase().replace(/i̇/g, 'i');
  let out = '';
  for (const ch of lower) {
    const k = FROM.indexOf(ch);
    out += k === -1 ? ch : TO[k];
  }
  return out;
}
